export class BaseListParams {
  count?: number;
  offset?: number;
  limit?: number;
  
  // Underscore-prefixed params for new API style
  _offset?: number;
  _limit?: number;

  constructor() {
    this.count = 0;
    this.offset = 0;
    this.limit = 25;

    this._offset = 0;
    this._limit = 25;
  }
}
